import { useMemo } from 'react';
import { FieldOption } from '../types';

/**
 * Marks fields as disabled once `fieldSelectionLimit` has been reached, so the field
 * picker only allows selecting fields that are already part of the filter. Split out of
 * `NewExpressionBuilder` so the disabling logic can be unit-tested independently of the
 * full component render.
 */
export const shouldDisableField = (field: FieldOption, selectedFieldNames: ReadonlySet<unknown>, isOverFieldNamesLimit: boolean): boolean =>
  isOverFieldNamesLimit && !selectedFieldNames.has(field.value);

export const useFieldProcessing = <T extends FieldOption>(
  fields: T[],
  selectedFieldNames: ReadonlySet<unknown>,
  isOverFieldNamesLimit: boolean | undefined
): T[] =>
  useMemo(
    () =>
      isOverFieldNamesLimit ? fields.map(field => (selectedFieldNames.has(field.value) ? field : { ...field, disabled: true })) : fields,
    [isOverFieldNamesLimit, fields, selectedFieldNames]
  );
